import React from "react";
import { adminApi as api } from "../../../util/api";
import { ImportModal } from "../../components/ImportModal";

export const ImportIcd10CodesModal = ({ onImport, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      file: {
        bytes: values.file,
      },
    };
    const res = await api.post("/admin/icd10_codes/import.json", params);

    if (onImport) {
      onImport(res.data?.meta?.message, res.data?.meta?.error_details);
    }
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Import Icd10 Codes..."
      exampleDownloadPath="/admin/icd10_codes/example"
    />
  );
};
